export const verifyIfNavigationNeedConfirmation = (routePaths) => (location, action) => {
    if (routePaths.map((x) => x.replace("/:id", "")).filter((x) => location.pathname.startsWith(x)).length > 0) {
        return true;
    }
    return "Masz niezapisane zmiany. Czy na pewno chcesz opuścić stronę?";
};
